/**
 * KidHQ frontend observability.
 *
 * No-op until both REACT_APP_SENTRY_DSN is set AND REACT_APP_SENTRY_ENABLED === "1".
 * Tags errors by category so they're filterable alongside the backend
 * (stripe, gmail, resend, scheduler, auth, billing, database).
 */
import * as Sentry from "@sentry/react";

let enabled = false;

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN || "";
  const flag = process.env.REACT_APP_SENTRY_ENABLED === "1";
  if (!dsn || !flag) {
    return false;
  }
  try {
    Sentry.init({
      dsn,
      environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "preview",
      release: process.env.REACT_APP_SENTRY_RELEASE || "kidhq-frontend@dev",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
      ],
      tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.1),
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      beforeSend(event) {
        return event;
      },
    });
    Sentry.setTag("service", "kidhq-frontend");
    enabled = true;
    return true;
  } catch (e) {
    // Never let observability break the app
    console.warn("Sentry init failed", e);
    return false;
  }
}

export function isEnabled() {
  return enabled;
}

export function captureException(err, category) {
  if (!enabled) return;
  try {
    Sentry.withScope((scope) => {
      if (category) scope.setTag("category", category);
      Sentry.captureException(err);
    });
  } catch {
    /* swallow */
  }
}

export const ErrorBoundary = Sentry.ErrorBoundary;
